import { render, staticRenderFns } from "./VerOrdenCompra.vue?vue&type=template&id=7c3bcb46&scoped=true"
import script from "./VerOrdenCompra.vue?vue&type=script&lang=js"
export * from "./VerOrdenCompra.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VerOrdenCompra.vue?vue&type=style&index=1&id=7c3bcb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3bcb46",
  null
  
)

export default component.exports